<div>
<ng-container #outlet [ngTemplateOutlet]="content"></ng-container>
</div>
<ng-template #content>
<div fxLayout="column" fxFlex="grow" class="display-container">

    <div *ngFor="let section of sections" [style.width.px]="displayWidth">

        <div style="width: 100%;" fxLayout="column" *ngIf="section.displayed" class="sections-display"
             [ngClass]="expandedId === section.id ? 'selected-section' : 'unselected-section'">

            <!--Section Title-->
            <div *ngIf="section.value" class="section-title" style="font-weight: bold; font-size: 16px; margin-bottom: 10px; color: #333; border-bottom: 1px solid #ddd; padding-bottom: 8px;">
                {{section.value}}
            </div>

            <!--Member Display-->

            <div fxLayout="row wrap" fxFlex="grow" [ngStyle]="{'align-items': section.align.value}">
                <div fxLayout="column" *ngFor="let member of section.members"
                     [fxFlex]="member.proportion ? +member.proportion.value : 100"
                     [ngStyle]="{'align-items': member.align.value}">

                    <div fxLayout="row" style="margin-bottom: 15px;">
                        {{member.title}}
                    </div>

                    <!--Image-->
                    <div *ngIf="member.type.type === 'image'">
                        <img style="object-fit: cover; width: 100%;" *ngIf="member.options.length > 0"
                             [src]="member.options[0].value" alt="no image">
                    </div>
                    <!---->

                    <!--Text-->
                    <div *ngIf="member.type.type === 'text'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <label>
                                <input style="width: 100%;" matInput placeholder="Κείμενο"/>
                            </label>
                        </mat-form-field>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                    <!-- TextArea-->
                    <div *ngIf="member.type.type === 'textarea'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <label>
                                <textarea matInput [(ngModel)]="member.value"></textarea>
                            </label>
                        </mat-form-field>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                    <!-- CheckBox-->
                    <div fxLayout="column" fxLayoutGap="10px"
                         *ngIf="member.type.type === 'checkbox'" fxFlex="grow">
                        <mat-checkbox
                                *ngFor="let option of member.options">{{option.label}}</mat-checkbox>
                    </div>
                    <!--                                -->
                    <!--Label-->
                    <div *ngIf="member.type.type === 'label'" fxFlex="grow" fxLayout="column">
                        <div fxLayout="row">
                        <quill-editor readOnly="readOnly" [modules]="{ toolbar: false }" [styles]="editorStylePreview"
                                     (onEditorCreated)="editorCreated($event, member.value)"></quill-editor>
                        </div>
                    </div>
                    <!--                                -->
                    <!--Radio Button-->
                    <div *ngIf="member.type.type === 'radio'" fxFlex="grow">
                        <mat-radio-group [(ngModel)]="member.value" fxLayout="row wrap">
                            <mat-radio-button  style="width:100%; margin: 5px;"
                                              *ngFor="let option of member.options"
                                               [value]="option"><label>{{option.label}}</label></mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <!--                                -->
                    <!--Toggle-->
                    <div *ngIf="member.type.type === 'toggle'" fxFlex="grow">
                        <mat-slide-toggle>ΟΧΙ/ΝΑΙ</mat-slide-toggle>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                    <!--  Dropdown-->
                    <div *ngIf="member.type.type === 'select'" fxFlex="grow">
                        <mat-form-field appearance="outline" fxFlex="grow">
                            <mat-select [(ngModel)]="member.value">
                                <mat-option *ngFor="let option of member.options"
                                            [value]="option">{{option.label}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <label *ngIf="member.mandatory">*</label>
                    </div>
                    <!--                                -->
                </div>
            </div>
            <!--        -->
        </div>
    </div>

</div>
</ng-template>
